var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.listFile),function(item){return _c('div',{key:item._id},[_c('BulkDuplicateItem',{attrs:{"item":item,"deleteDesign":_vm.deleteDesign}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }